import { TOGGLE_THEME } from "./types";

export const themeToggle = (themeType) => {
  return {
    type: TOGGLE_THEME,
    payload: themeType == true ? "dark" : "light",
  };
};
